export const _setDataGridCounts = (state, action) => {
  state.dataGridCounts = [...state.dataGridCounts, action.payload];
};
